import { render, staticRenderFns } from "./CreateSupplierDialog.vue?vue&type=template&id=6646d84a&scoped=true"
import script from "@/views/Settings/Suppliers/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Suppliers/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Suppliers/create-dialog.scss?vue&type=style&index=0&id=6646d84a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646d84a",
  null
  
)

export default component.exports